import ICONS from '@/shared/entities/constants/icons';

export const LEAD_INDICATION_PAGE = Object.freeze({
  MENU_NAME: 'Vitta por Assinatura',
  TITLE: 'Indicações',
  DESCRIPTION: 'Acompanhe e envie indicações de leads para o fluxo de Vida por Assinatura.',
  PRIMARY_ACTION_LABEL: 'Enviar indicação',
  ICON: ICONS.HEART,
  EMPTY_TITLE: 'Nenhuma indicação enviada até o momento.',
  EMPTY_DESCRIPTION: 'Envie uma nova indicação para começar a acompanhar os leads.',
  WRITE_PERMISSION_ALERT_TITTLE: 'Você não tem permissão para enviar ou alterar indicações',
  WRITE_PERMISSION_ALERT_MESSAGE: 'No momento, seu perfil não possui as permissões necessárias para realizar o envio de indicações. Entre em contato com o administrador do sistema para solicitar o acesso.',
});
